import { Component, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "claas-not-found",
  imports: [RouterLink, TranslatePipe],
  templateUrl: "./not-found.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./not-found.scss",
})
export class NotFoundComponent {}
